<template>
  <div class="crewHome">
    <div class="crewHome-content">
      <el-form :inline="true" :model="formInline" class="other-form-inline">
        <!-- <el-form-item class="flex-form">
          <el-date-picker
            class="hide-icon"
            type="date"
            placeholder="开始时间"
            v-model="formInline.date1"
            style="width: 100px"
          ></el-date-picker>
          <span class="line" style="margin: 0 3px">-</span>
          <el-date-picker
            class="hide-icon"
            placeholder="结束时间"
            v-model="formInline.date2"
            style="width: 100px"
          ></el-date-picker>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-select
            v-model="formInline.region"
            placeholder="意向岗位"
            style="width: 135px"
          >
            <el-option label="区域一" value="shanghai"></el-option>
            <el-option label="区域二" value="beijing"></el-option>
          </el-select>
        </el-form-item> -->

        <el-form-item>
          <el-input
            v-model="formInline.userName"
            placeholder="搜索名字"
            style="width: 150px"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="formInline.crewState"
            placeholder="任职状态"
            style="width: 135px"
          >
            <el-option label="任职状态" value=""></el-option>
            <el-option label="在职" value="1"></el-option>
            <el-option label="离职" value="2"></el-option>
            <!-- <el-option label="审核不通过" value="3"></el-option> -->
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="formInline.userState"
            placeholder="所属劳务公司"
            style="width: 135px"
          >
            <el-option label="所属劳务公司" value=""></el-option>
            <el-option label="本劳务公司" value="1"></el-option>
            <el-option label="其他劳务公司" value="2"></el-option>
            <!-- <el-option label="审核不通过" value="3"></el-option> -->
          </el-select>
        </el-form-item>
        <el-form-item>
          <div class="other-search" @click="onSubmit">
            <i class="el-icon-search"></i>
          </div>
        </el-form-item>
        <el-form-item>
          <div class="other-search2" @click="onAdd">添加船员</div>
        </el-form-item>
      </el-form>
      <div style="clear: both"></div>
      <el-divider class="other-divider"></el-divider>
      <div class="other-table">
        <el-table
          :data="tableData"
          header-row-class-name="other-header"
          row-class-name="other-row"
          height="100%"
        >
          <el-table-column fixed="left" prop="userName" label="姓名" min-width="100">
            <template slot-scope="scope">
              <span
                style="color: #409eff; cursor: pointer"
                @click="comDetail(scope)"
                >{{ scope.row.userName }}</span
              >
            </template>
          </el-table-column>
          <el-table-column prop="loginName" label="登录名" min-width="180">
          </el-table-column>
          <el-table-column prop="sex" label="性别" min-width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.sex == '0'">男</span>
              <span v-if="scope.row.sex == '1'">女</span>
            </template>
          </el-table-column>
          <el-table-column prop="age" label="年龄" min-width="80">
          </el-table-column>
          <el-table-column prop="workingYear" label="航海经验" min-width="100">
          </el-table-column>
          <el-table-column prop="degreesName" label="学历" min-width="80">
          </el-table-column>
          <el-table-column prop="postName" label="意向职务" min-width="100">
          </el-table-column>
          <el-table-column prop="cellphoneNo" label="联系方式" min-width="120">
          </el-table-column>
          <el-table-column
            prop="userState"
            label="所属劳务公司"
            min-width="120"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.userState == '1'">本劳务公司</span>
              <span v-if="scope.row.userState == '2'">其他劳务公司</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="crewType" label="船员类型" min-width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.crewType == '1'">自有船员</span>
              <span v-if="scope.row.crewType == '2'">借调船员</span>
            </template>
          </el-table-column> -->
          <el-table-column prop="crewState" label="任职状态" min-width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.crewState == '1'">在职</span>
              <span v-if="scope.row.crewState == '2'">离职</span>
            </template>
          </el-table-column>
          <el-table-column prop="joinTime" label="加入时间" min-width="120">
          </el-table-column>
          <el-table-column prop="onShipDate" label="上船时间" min-width="120">
          </el-table-column>
          <el-table-column label="操作" min-width="340">
            <template slot-scope="scope">
              <!-- <el-button
                type="text"
                size="small"
                class="other-watch"
                @click="comDetail(scope)"
              >
                查看
              </el-button> -->
              <el-button
                type="text"
                size="small"
                class="other-watch"
                @click="editList(scope)"
              >
                编辑
              </el-button>

              <el-button
                v-if="scope.row.crewState != '1'"
                type="text"
                size="small"
                class="other-com"
                @click="choseCom(scope)"
              >
                推送企业
              </el-button>
              <el-button
                v-if="
                  scope.row.userState == '1' ||
                  scope.row.isUnbindshipCompyCrew == '1'
                "
                type="text"
                size="small"
                class="other-del"
                @click="passInvite(scope.row)"
              >
                解除绑定
              </el-button>
              <el-button
                type="text"
                size="small"
                class="other-watch"
                @click="resetPass(scope.row)"
              >
                重置密码
              </el-button>
              <!-- <el-button
                v-if="scope.row.userState == '1'"
                type="text"
                size="small"
                class="other-del"
                @click="delInvite(scope)"
              >
                解除本公司绑定
              </el-button>
              <el-button
                v-if="scope.row.isUnbindshipCompyCrew == '1'"
                type="text"
                size="small"
                class="other-del"
                @click="sendInvite(scope)"
              >
                解除船企绑定
              </el-button> -->
              <el-button
                type="text"
                size="small"
                class="other-watch"
                @click="passList(scope.row)"
              >
                推荐记录
                <span
                  class="userState-on"
                  v-if="scope.row.recommendNotPassFlag"
                ></span>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div>
        <div class="other-block">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage1"
            layout="total, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      class="other-dialog"
      width="350px"
      title="解除绑定"
      :visible.sync="passCompanyVisible"
      ref="vueRef"
      :before-close="handleClosePass"
    >
      <el-form
        :rules="rules"
        ref="itemUser"
        label-width="70px"
        :model="passFrom"
        class="other-form"
      >
        <el-form-item label="解除类型" prop="clientCompanyId">
          <el-radio
            v-if="passDemo.userState == '1'"
            v-model="passFrom.comPassFlag"
            label="1"
            >本公司</el-radio
          >
          <el-radio
            v-if="passDemo.isUnbindshipCompyCrew == '1'"
            v-model="passFrom.comPassFlag"
            label="2"
            >船企</el-radio
          >
        </el-form-item>
      </el-form>
      <span slot="footer" class="other-footer">
        <el-button @click="passCompanyVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="passCommitCreww()"
          :loading="passLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      class="other-dialog"
      width="350px"
      title="推送企业"
      :visible.sync="companyVisible"
      ref="vueRef"
      :before-close="handleClose"
    >
      <el-form
        :rules="rules"
        ref="itemUser"
        label-width="70px"
        :model="formLabelAlign"
        class="other-form"
      >
        <el-form-item label="委托企业" prop="clientCompanyId">
          <el-select
            v-model="jobParams.clientCompanyId"
            filterable
            remote
            reserve-keyword
            @change="checkCompany()"
            placeholder="请输入职位所属公司"
            :remote-method="remoteMethod"
          >
            <el-option
              v-for="item in companyList"
              :key="item.COMPANY_ID"
              :label="item.company_name"
              :value="item.COMPANY_ID"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="招聘职位" prop="userName">
          <!-- <el-input
            v-model="jobParams.userName"
            placeholder="招聘职位"
          ></el-input> -->
          <el-select
            v-model="jobParams.userName"
            filterable
            placeholder="招聘职位"
            style="width: 135px"
          >
            <el-option
              v-for="item in jobList"
              :key="item.postCode"
              :label="item.postName"
              :value="item.postName"
            ></el-option>
            <!-- <el-option label="在职" value="1"></el-option>
            <el-option label="离职" value="0"></el-option> -->
            <!-- <el-option label="审核不通过" value="3"></el-option> -->
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="other-footer">
        <el-button @click="companyVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="commitCreww()"
          :loading="remendLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <pass-crew-list ref="passCrewList" @update="update"></pass-crew-list>
  </div>
</template>
<script>
import passCrewList from "../modal/passCrewList.vue";
import {
  getCrewInfo2,
  getCompanyNameBykeyword,
  rememendCrew,
  getshipPositions,
  updateAgentUserState,
  updateUnBindUserToShipCompy,
  recommendCheckCyServquali,
  resetPasswordByIdCardNo
} from "@/apis/index";
export default {
  components: { passCrewList },
  data() {
    return {
      formInline: {},
      tableData: [],
      currentPage1: 1,
      currentPage2: 5,
      currentPage3: 5,
      currentPage4: 4,
      companyVisible: false,
      formLabelAlign: {},
      total: 0,
      pageNo: 1,
      pageSize: 10,
      jobParams: {},
      companyList: [],
      keyword: "",
      userId: "",
      postCode: "",
      jobList: [],
      remendLoading: false,
      rules: {
        clientCompanyId: [
          { required: true, message: "请选择公司", trigger: "blur" },
        ],
        userName: [{ required: true, message: "请选择职位", trigger: "blur" }],
      },
      passFrom: {
        comPassFlag: "1",
      },
      passCompanyVisible: false,
      passLoading: false,
      passDemo: {},
    };
  },
  mounted() {
    this.getCrewInfoList();
    this.selectDictCertPostLists();
  },
  methods: {
    async getCrewInfoList() {
      let res = await getCrewInfo2({
        pageSize: this.pageSize,
        pageNo: this.pageNo,
        agentAuditState: "2",
        ...this.formInline,
      });
      this.total = res.data.rowCount;
      res.data.resultList.forEach((item) => {
        if (item.joinTime) {
          item.joinTime = item.joinTime.split(" ")[0];
        }
      });
      this.tableData = res.data.resultList;
    },
    onSubmit() {
      this.pageNo = 1;
      this.currentPage1 = 1;
      this.getCrewInfoList();
    },
    handleOpen() {},
    getTable() {
      const customObject = {
        date1: "张玉峰",
        date2: "男",
        date3: "46",
        date4: "15",
        date5: "本科",
        date6: "大管轮",
        date7: "15365321563",
        date8: "入职",
        date9: "2023-8-10",
      };
      for (let i = 0; i < 10; i++) {
        this.tableData.push(customObject);
      }
    },
    //职位
    async getCompanyNameBykeywordList() {
      const res = await getCompanyNameBykeyword({ keyword: this.keyword });
      // console.log(res);
      this.companyList = res.data;
    },
    //职位
    async commitCreww() {
      const res = await recommendCheckCyServquali({
        userId: this.userId,
      });
      if (res.data) {
        this.rememendCrewPass();
      } else {
        this.$message({
          message: "请确认简历的完整性（工作经历）!",
          type: "warning",
          customClass: "warning-index",
        });
        this.$confirm("确定要推送吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            // 执行删除操作
            // this.$message({
            //   message: "删除成功",
            //   type: "success",
            // });
            this.rememendCrewPass();
            // console.log(scope);
          })
          .catch(() => {
            // 取消删除操作
            console.log("取消删除");
          });
      }
    },
    update() {
      this.getCrewInfoList();
    },
    async rememendCrewPass() {
      if (!this.jobParams.clientCompanyId) {
        this.$message.error("请选择委托企业");
        return;
      }
      if (!this.jobParams.userName) {
        this.$message.error("请选择职位");
        return;
      }
      this.jobList.forEach((item) => {
        if (item.postName == this.jobParams.userName) {
          this.postCode = item.postCode;
        }
      });
      this.remendLoading = true;
      const res = await rememendCrew({
        agentCompanyId: sessionStorage.getItem("companyId"),
        postCode: this.postCode,
        postName: this.jobParams.userName,
        recommendCompanyId: this.jobParams.clientCompanyId,
        userId: this.userId,
      });
      // console.log(res);
      if (res.code > 0) {
        this.$message({
          message: "成功",
          type: "success",
        });
        this.remendLoading = false;
        this.companyVisible = false;
      } else {
        this.$message({
          message: res.msg,
          type: "warning",
        });
        this.remendLoading = false;
      }

      // this.companyList = res.data;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getCrewInfoList();
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getCrewInfoList();
      // console.log(`当前页: ${val}`);
    },
    choseCom(scope) {
      
      this.userId = scope.row.userId;
      // this.jobList.forEach((item) => {
      //   if (item.postName == scope.row.postName) {
      //     this.postCode = item.postCode;
      //   }
      // });
      this.companyVisible = true;
      this.keyword = '宁波远洋'
      this.getCompanyNameBykeywordList();
      this.$set(this.jobParams, "clientCompanyId", '8f42b387b3ae4a8686e0afc79ed59343');
      // this.$set(this.jobParams, "userName", scope.row.postName);
      this.selectDictCertPostLists()
      // this.$set(this.jobParams, "clientCompanyId", "");
      // this.getCrewDetailList(this.userId);
    },
    //职位
    async selectDictCertPostLists() {
      const res = await getshipPositions({
        companyId: this.jobParams.clientCompanyId,
      });
      this.jobList = res.data;
    },
    checkCompany() {
      this.$set(this.jobParams,"userName","")
      this.selectDictCertPostLists();
    },
    handleClose() {
      this.companyVisible = false;
    },
    comDetail(scope) {
      // console.log(scope);
      let name = scope.row.userName;
      // console.log(name);
      this.$router.push({
        name: "crewDetail",
        params: {
          name: name,
          userId: scope.row.userId,
          idCardNo: scope.row.idCardNo,
        },
      });
    },
    onAdd() {
      this.$router.push({ name: "addCrew", params: { userId: "0" } });
    },
    editList(scope) {
      this.$router.push({
        name: "addCrew",
        params: { userId: scope.row.userId },
      });
    },
    remoteMethod(query) {
      this.keyword = query;
      this.getCompanyNameBykeywordList();
    },
    delInvite(scope) {
      this.$confirm("确定要解除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 执行删除操作
          // this.$message({
          //   message: "删除成功",
          //   type: "success",
          // });
          this.delList(scope);
          // console.log(scope);
        })
        .catch(() => {
          // 取消删除操作
          console.log("取消删除");
        });
    },
    async delList(row) {
      let res = await updateAgentUserState({
        userId: row.userId,
      });
      if (res.code) {
        this.$message({
          message: "解除成功",
          type: "success",
        });
        this.passCompanyVisible = false;
        this.getCrewInfoList();
      }

      // console.log(res);;
    },
    sendInvite(scope) {
      this.$confirm("确定要解除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 执行删除操作
          // this.$message({
          //   message: "删除成功",
          //   type: "success",
          // });
          this.sendList(scope);
          // console.log(scope);
        })
        .catch(() => {
          // 取消删除操作
          console.log("取消删除");
        });
    },
    async sendList(row) {
      let res = await updateUnBindUserToShipCompy({
        userId: row.userId,
      });
      if (res.code) {
        this.$message({
          message: "解除成功",
          type: "success",
        });
        this.passCompanyVisible = false;
        this.getCrewInfoList();
      }

      // console.log(res);;
    },
    passList(info) {
      this.$refs.passCrewList.showToggle(info);
    },
    passCommitCreww() {
      if (this.passFrom.comPassFlag == "1") {
        this.delInvite(this.passDemo);
      } else if (this.passFrom.comPassFlag == "2") {
        this.sendInvite(this.passDemo);
      }
    },
    handleClosePass() {
      this.passCompanyVisible = false;
    },
    passInvite(item) {
      this.passDemo = item;
      this.passCompanyVisible = true;
    },
    resetPass(scope) {
      let tips = `是否将 ${scope.userName} 重置密码为船员身份证后8位吗？`
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 执行删除操作
          // this.$message({
          //   message: "删除成功",
          //   type: "success",
          // });
          this.resetList(scope);
          // console.log(scope);
        })
        .catch(() => {
          // 取消删除操作
          console.log("取消删除");
        });
    },
    async resetList(row) {
      await resetPasswordByIdCardNo({
        userId: row.userId
      });
      this.$message({
        message: "重置成功",
        type: "success",
      });
    },
  },
};
</script>
